export const PhotoUploadState = {
  EMPTY: 'EMPTY',
  IN_PROGRESS: 'IN_PROGRESS',
  SENT: 'SENT',
  ERROR: 'ERROR',
  PENDING: 'PENDING',
};
